import { Box } from '@mui/material';

import { OrderInventoryTable } from 'widgets/InventoryTable/ui/OrderInventoryTable/OrderInventoryTable';

export const CustomListAddItemsInventory = () => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            height: '100%',
        }}
    >
        <OrderInventoryTable hideFooter />
    </Box>
);
